import {Grid} from "@material-ui/core"
import * as React from "react"
import {CreateHash} from "./CreateHash"
import {ValidateHash} from "./ValidateHash"

export const BasicTools: React.FC = () => {
    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <CreateHash/>
            </Grid>
            <Grid item={true} xs={12}>
                <ValidateHash/>
            </Grid>
        </Grid>
    )
}
